import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { B2bService } from 'src/service/b2b.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { KeyValues10, LocalService, Status } from 'src/service/local.service';

@Component({
  selector: 'app-b2b-account',
  templateUrl: './b2b-account.component.html',
  styleUrl: './b2b-account.component.scss'
})
export class B2bAccountComponent {
  @ViewChild('content_b2b_account')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["b2b"];
  @Input() b2bAccountId: string = ''; data: KeyValues10;

  htmlId: string = ''; elementIds: any;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, private b2bService: B2bService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      save: 'btn_save' + this.htmlId
    }
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onReset() {
  }

  onCloseTrigger(event?: any) {
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onLoad() {
    this.onReset();
    if (this.b2bAccountId && this.b2bAccountId.length > 5) {
      this.b2bService.getB2bAccount(this.b2bAccountId).subscribe(result => {
        this.data = result;
      });
    } else {
      this.data = {
        v1: ''
      } as KeyValues10;
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.onSave();
      } break;
    }
  }

  onSave() {
    this.b2bService.saveB2bAccount(this.data).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onCloseTrigger();
      }
    });
  }

}
